export const calendarsFallbackSkuMappings =
{
    currency: 'USD',
    products: [
        {
            type: '12x12',
            skus: ['WALLCAL_12X12']
        },
        {
            type: '8x11',
            skus: ['WALLCAL_8X11']
        },
        {
            type: 'wall-calendars-mobile',
            skus: ['WALLCAL_8X11', 'WALLCAL_12X12']
        },
        {
            type: 'easel-calendars',
            skus: ['EASEL_CALENDAR']
        },
        {
            type: 'desk-calendars',
            skus: ['CALENDARDESK_5X11']
        },
        {
            type: 'magnet-calendars',
            skus: ['MAGNET02']
        },
        {
            type: 'calendar-posters',
            skus: ['CLNDR_POSTER_16X20', 'CLNDR_POSTER_20X30']
        },
        {
            type: 'mouse-pad',
            skus: ['MOUSEPAD01', 'MOUSEPAD_BRKT02']
        },
        {
            type: 'canvas-calendars',
            skus: ['HANGING_CANVAS_PRINT_11X14', 'HANGING_CANVAS_PRINT_16X20', 'HANGING_CANVAS_PRINT_20X30']
        }
    ]
};
